module.exports = __webpack_public_path__ + "img/compass-icon.2cc363dc.png";